import React from 'react';
import { Layout as AntdLayout } from 'antd';

type LayoutType = React.FC<React.ComponentProps<typeof AntdLayout>> & {
  Header: typeof AntdLayout.Header;
  Footer: typeof AntdLayout.Footer;
  Content: typeof AntdLayout.Content;
  Sider: typeof AntdLayout.Sider;
};

const Layout: LayoutType = (props) => {
  return <AntdLayout {...props} />;
};

Layout.Header = AntdLayout.Header;
Layout.Footer = AntdLayout.Footer;
Layout.Content = AntdLayout.Content;
Layout.Sider = AntdLayout.Sider;

export default Layout;